import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { EntityPagination } from "components/common";
import { useAuditSheetNavigation } from "../hooks/auditSheetNavigationContext";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const AuditSheetDialogTitle: React.FC = () => {
  const { items, index, current, goTo } = useAuditSheetNavigation();

  return (
    <Grid container alignItems="flex-start" wrap="nowrap" columnGap={2}>
      <Grid item xs zeroMinWidth className={cssExports.auditSheetDialogTitleText}>
        {current.title}
      </Grid>
      {items.length > 1 && (
        <Grid item className={cssExports.auditSheetDialogNavigation}>
          <EntityPagination
            total={items.length}
            numPerPage={items.length}
            initialIndex={index}
            onCurrentIndexUpdate={goTo}
            navigationText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Account)}
            preserveIndexOnPageNumberChange
          />
        </Grid>
      )}
    </Grid>
  );
};

export default AuditSheetDialogTitle;
